
import React from 'react';
import { CardDescription, CardTitle, CardHeader } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Info } from 'lucide-react';

interface AuthWelcomeHeaderProps {
  isUpgrading: boolean;
  isJoiningTrip: boolean;
  pendingTripName: string | null;
  isResettingPassword: boolean;
}

/**
 * Header component for the auth page with different messages based on context
 */
const AuthWelcomeHeader: React.FC<AuthWelcomeHeaderProps> = ({
  isUpgrading,
  isJoiningTrip,
  pendingTripName,
  isResettingPassword
}) => {
  return (
    <CardHeader className="space-y-1">
      <CardTitle className="text-2xl font-bold text-center">WeTrippy</CardTitle>
      <CardDescription className="text-center">
        {isUpgrading 
          ? "Upgrade from guest to a full account" 
          : isJoiningTrip
            ? "Sign in or create an account to join a trip"
            : "Sign in or create an account to start planning your trip"}
      </CardDescription>
      
      {isJoiningTrip && (
        <Alert className="mt-2 bg-blue-50 border-blue-200">
          <Info className="h-4 w-4 text-blue-500" />
          <AlertDescription className="text-blue-800">
            {pendingTripName 
              ? `Please sign in or create an account to join "${pendingTripName}".` 
              : "Please sign in or create an account to join this trip."}
            You'll be automatically added after authentication.
          </AlertDescription>
        </Alert>
      )}
      
      {isResettingPassword && (
        <Alert className="mt-2 bg-green-50 border-green-200">
          <Info className="h-4 w-4 text-green-500" />
          <AlertDescription className="text-green-800">
            Please check your email for a password reset link. Click the link to set a new password.
          </AlertDescription>
        </Alert>
      )}
    </CardHeader>
  );
};

export default AuthWelcomeHeader;
